import * as api from '../api';

// Convenience functions for webhook operations
export const getWebhookSubscriptions = params => api.webhooks.list(params).then(res => res.data);
export const createWebhookSubscription = data => api.webhooks.create(data).then(res => res.data);
export const updateWebhookSubscription = (id, data) => api.webhooks.update(id, data).then(res => res.data);
export const deleteWebhookSubscription = id => api.webhooks.delete(id).then(res => res.data);
export const rotateWebhookSecret = id => api.webhooks.rotateSecret(id).then(res => res.data);
export const getWebhookDeliveryLogs = id => api.webhooks.getDeliveryLogs(id).then(res => res.data);